<template>
    <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Actions" hide-footer :centered="true" v-model="open">
        <b-form class="pb-10">
            <gofix-form-dropdown 
                label="Status" 
                vLabel="name" 
                :filterable="false" 
                v-model="obj.status" 
                :options="jobOptionStatus">
            </gofix-form-dropdown>
            <dropdown-user-duties 
                v-if="Item.status == 'New'"
                label="Submitted By"
                :project-id="Item.project && Item.project.id ? Item.project.id : null"
                :reduce="option => option.user_id"
                :safetyOnlyFM="true"
                role-name="Safety Officer"
                v-model="obj.submitted_by_id">
            </dropdown-user-duties>
            <dropdown-user-duties 
                v-if="Item.status == 'Submitted'"
                label="Acknowledged By"
                :project-id="Item.project && Item.project.id ? Item.project.id : null"
                :company-id="Item.supplier && Item.supplier.id ? Item.supplier.id : null"
                :reduce="option => option.user_id"
                role-name="Contractor Supervisor"
                v-model="obj.acknowledged_by_id">
            </dropdown-user-duties>
            <template v-if="Item.status == 'Contractor Supervisor Acknowledged'">
                <dropdown-user-duties 
                    v-if="jobOptionStatus.includes('Completed')"
                    label="Completed By"
                    :project-id="Item.project && Item.project.id ? Item.project.id : null"
                    :company-id="Item.supplier && Item.supplier.id ? Item.supplier.id : null"
                    :reduce="option => option.user_id"
                    role-name="Contractor Supervisor"
                    v-model="obj.completed_by_id">
                </dropdown-user-duties>
                <dropdown-user-duties 
                    v-if="jobOptionStatus.includes('Pending Acknowledgement')"
                    label="Pending Acknowledgement By"
                    :project-id="Item.project && Item.project.id ? Item.project.id : null"
                    :reduce="option => option.user_id"
                    :safetyOnlyFM="true"
                    role-name="Safety Officer"
                    v-model="obj.pending_acknowledgement_by_id">
                </dropdown-user-duties>
            </template>
            
            <b-row v-if="Item.status == 'New'">
                <b-col md="6">
                    <gofix-form-input-date v-model="obj.submitted_at" label="Submitted Date"></gofix-form-input-date>
                </b-col>
                <b-col md="6">
                    <gofix-form-input-time label="Submitted Time" v-model="obj.submitted_at_hour"></gofix-form-input-time>
                </b-col>
            </b-row>
            <b-row v-if="Item.status == 'Submitted'">
                <b-col md="6">
                    <gofix-form-input-date v-model="obj.acknowledged_at" label="Acknowledged Date"></gofix-form-input-date>
                </b-col>
                <b-col md="6">
                    <gofix-form-input-time label="Acknowledged Time" v-model="obj.acknowledged_at_hour"></gofix-form-input-time>
                </b-col>
            </b-row>
            <b-row v-if="Item.status == 'Contractor Supervisor Acknowledged' && jobOptionStatus.includes('Completed')">
                <b-col md="6">
                    <gofix-form-input-date v-model="obj.completed_at" label="Completed Date"></gofix-form-input-date>
                </b-col>
                <b-col md="6">
                    <gofix-form-input-time label="Completed Time" v-model="obj.completed_at_hour"></gofix-form-input-time>
                </b-col>
            </b-row>
            <b-row v-if="Item.status == 'Contractor Supervisor Acknowledged' && jobOptionStatus.includes('Pending Acknowledgement')">
                <b-col md="6">
                    <gofix-form-input-date v-model="obj.pending_acknowledgement_at" label="Pending Acknowledgement Date"></gofix-form-input-date>
                </b-col>
                <b-col md="6">
                    <gofix-form-input-time label="Pending Acknowledgement Time" v-model="obj.pending_acknowledgement_at_hour"></gofix-form-input-time>
                </b-col>
            </b-row>
        </b-form>
        <b-button-group class="d-block text-right">
            <gofix-button label="APPLY" @click="handleUpdateStatus" :loading="loading" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
    import moment from 'moment';
    export default {
        name: 'modal-remark-follow-up',
        components: {
            DropdownUserDuties
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            checklistEntries: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                open: false,
                loading: false,
                obj: {
                    status: null,
                    completed_by_id: null,
                    acknowledged_by_id: null,
                    submitted_by_id: null,
                    submitted_at: null,
                    submitted_at_hour: null,
                    acknowledged_at: null,
                    acknowledged_at_hour: null,
                    completed_at: null,
                    completed_at_hour: null,
                    pending_acknowledgement_by_id: null,
                    pending_acknowledgement_at: null,
                    pending_acknowledgement_at_hour: null,
                },
                option_status: {
                    'New': ['Submitted'],
                    'Submitted': ['Contractor Supervisor Acknowledged'],
                    'Contractor Supervisor Acknowledged': ['Completed'],                 
                    'Pending Acknowledgement': ['Completed'],             
                },
            }
        },
        computed: {
            ...mapGetters({
                Item: 'SafetyAppController/safetyJob',
                JobWorkFinding: "SafetyAppController/workFindings",
            }),
            jobOptionStatus() {
                if(this.Item) {
                    if(this.Item.status == 'New') {
                        if(this.JobWorkFinding && this.JobWorkFinding.items && this.JobWorkFinding.items.length) {
                            let isAllGoodPratice = this.JobWorkFinding.items.every(item => item.observations_non_compliances.toLowerCase() == 'good practice');
                            if(isAllGoodPratice) {
                                return ['Completed'];
                            }
                        }
                    }
                    
                    if(this.Item.status == 'Contractor Supervisor Acknowledged') {
                        if(this.JobWorkFinding && this.JobWorkFinding.items && this.JobWorkFinding.items.length) {
                            let isAnyRectified = this.JobWorkFinding.items.some(item => item.observations_non_compliances.toLowerCase() != 'good practice');
                            if(isAnyRectified) {
                                return ['Pending Acknowledgement'];
                            }
                        }
                    }
                }
                return this.option_status[this.Item.status];
            },
        },
        created() {},
        watch: {
            open: async function(val) {
                this.$emit('input', val);
                if(val) {
                    if(!this.JobWorkFinding || !this.JobWorkFinding.items || !this.JobWorkFinding.items.length) {
                        await this.getWorkFindings();
                    }
                    await this.handleNextAction();
                    
                }
            },
            value: function(val) {
                this.open   = val;
            },
        },
        methods: {
            async handleNextAction() {
                this.obj = Object.assign(this.obj, {
                    status: null,
                    completed_by_id: this.Item.completed_by_id,
                    acknowledged_by_id: this.Item.acknowledged_by_id,
                    submitted_by_id: this.Item.submitted_by_id,
                    submitted_at: this.Item.submitted_at ? new Date(this.Item.submitted_at) : null,
                    submitted_at_hour: this.Item.submitted_at ? moment(new Date(this.Item.submitted_at)).format("HH:mm") : null,
                    acknowledged_at: this.Item.acknowledged_at ? new Date(this.Item.acknowledged_at) : null,
                    acknowledged_at_hour: this.Item.acknowledged_at ? moment(new Date(this.Item.acknowledged_at)).format("HH:mm") : null,
                    completed_at: this.Item.completed_at ? new Date(this.Item.completed_at) : null,
                    completed_at_hour: this.Item.completed_at ? moment(new Date(this.Item.completed_at)).format("HH:mm") : null,
                    pending_acknowledgement_by_id: this.Item.pending_acknowledgement_by_id,
                    pending_acknowledgement_at: this.Item.pending_acknowledgement_at ? new Date(this.Item.pending_acknowledgement_at) : null,
                    pending_acknowledgement_at_hour: this.Item.pending_acknowledgement_at ? moment(new Date(this.Item.pending_acknowledgement_at)).format("HH:mm") : null,
                });
            },
            handleUpdateStatus() {
                if(!this.obj.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                /* All checklists need to be ticked */
                let flagChecklist = false;
                if(this.Item.status == 'New') {
                    for(let i = 0; i < this.checklistEntries.length; i++) {
                        const item = this.checklistEntries[i];
                        if(item.children && item.children.length > 0) {
                            for(let j = 0; j < item.children.length; j++) {
                                const child = item.children[j];
                                if(child.safety_checklist_entries && child.safety_checklist_entries.length) {
                                    for(let k = 0; k < child.safety_checklist_entries.length; k++) {
                                        const entry = child.safety_checklist_entries[k];
                                        if(entry.input.value === false && entry.status == 'Unfilled') {
                                            flagChecklist = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        if(item.safety_checklist_entries && item.safety_checklist_entries.length) {
                            for(let k = 0; k < item.safety_checklist_entries.length; k++) {
                                const entry = item.safety_checklist_entries[k];
                                if(entry.input.value === false && entry.status == 'Unfilled') {
                                    flagChecklist = true;
                                    break;
                                }
                            }
                        }

                        if(flagChecklist) break;
                    }
                }

                if(flagChecklist) {
                    return this.$alertNotification("Please fill all checklist items before submit", "danger");
                }

                if(this.Item.status == 'Contractor Supervisor Acknowledged' && this.obj.status == 'Pending Acknowledgement') {
                    if(this.JobWorkFinding && this.JobWorkFinding.items && this.JobWorkFinding.items.length) {
                        let isAllRectified = this.JobWorkFinding.items.every(item => item.status && item.status.toLowerCase() == 'rectified');
                        if(!isAllRectified) {
                            return this.$alertNotification("Please rectify all observations before changing status to Pending Acknowledgement", "danger");
                        }
                    }
                }

                if (this.loading) return;
                this.loading = true;

                let params = this.processJob(this.obj);
                if(params === false) return

                this.$store
                    .dispatch("SafetyAppController/updateSafetyStatus", {
                        data: params,
                        id: this.Item.id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "safe_inspection_checklist"));
                        this.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                if(status == 'contractor supervisor acknowledged') status = 'acknowledged';
                if(status == 'pending acknowledgement') status = 'pending_acknowledgement';
                const defaultStatus = {
                    'submitted': {
                        status: 'Submitted',
                        submitted_by_id: data.submitted_by_id || null,
                        submitted_at: null,
                    },
                    'acknowledged': {
                        status: 'Contractor Supervisor Acknowledged',
                        acknowledged_by_id: data.acknowledged_by_id || null,
                        acknowledged_at: null,
                    },
                    'completed': {
                        status: 'Completed',
                        completed_by_id: data.completed_by_id || null,
                        completed_at: null,
                    },
                    'pending_acknowledgement': {
                        status: 'Pending Acknowledgement',
                        pending_acknowledgement_by_id: data.pending_acknowledgement_by_id || null,
                        pending_acknowledgement_at: null,
                    },
                };
                

                const obj = defaultStatus[status];

                if(!obj[`${status}_by_id`]) {
                    this.$alertNotification(`Please select ${obj.status} By`, "danger");
                    return false
                }

                if (data[`${status}_at`]) {
                    obj[`${status}_at`] = moment(new Date(data[`${status}_at`])).format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            },
            async getWorkFindings() {
                await this.$store.dispatch("SafetyAppController/getWorkFindings", {
                    isCMS: false,
                    filter: {
                        safety_job_id: this.Item.id
                    },
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc"
                })
            },
        }
    }
</script>
